<template>
    <div class="form-group">
        <input
            :value ="value"
            @keyup.enter="$emit('enter')"
            @input="$emit('input',$event.target.value)"
            :type="type"
            :name="name"
            :placeholder="placeholder"
            v-focus
            class="form-control text-info mt-3 next-line input-height"
        />
        <i
            class="material-icons text-info mr-2 pointer"
            style="float: right;position: relative;top:-28px;"
        >{{material_icon}}</i>
    </div>
</template>

<script>
export default {
    name : 'Form',
    props: {
        value: String,
        placeholder: String,
        type: String,
        name: String,
        material_icon: String
    }
};
</script>